export const SET_DO_AMT_ORDERS = 'SET_DO_AMT_ORDERS';
export const SET_LOADER = 'SET_LOADER';
export const SET_EDIT = 'SET_EDIT';
export const SET_SAVE = 'SET_SAVE';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';
export const SET_DO_ORDER_ID = 'SET_DO_ORDER_ID';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_UNIQUE_ROW = 'SET_UNIQUE_ROW';
export const SELECT_FILE = 'SELECT_FILE';